import { Box, Stack, TextField, Typography } from "@mui/material";
import { QuestionCard } from "../mobilePreview.style";

type Props = {
  currentQuestion: any;
};

const AddressFieldPreview = ({ currentQuestion }: Props) => {
  const { properties } = currentQuestion;
  return (
    <Box sx={{ ...QuestionCard, p: 2 }}>
      {properties?.zipcode && (
        <Stack gap={1} mb={1}>
          <Typography variant="body1" fontWeight={500}>
            Zipcode
          </Typography>
          <TextField name="zipcode" fullWidth placeholder="Zipcode" />
        </Stack>
      )}
      {properties?.city && (
        <Stack gap={1} mb={1}>
          <Typography variant="body1" fontWeight={500}>
            City
          </Typography>
          <TextField name="city" fullWidth placeholder="City" />
        </Stack>
      )}
      {properties?.state && (
        <Stack gap={1} mb={1}>
          <Typography variant="body1" fontWeight={500}>
            State
          </Typography>
          <TextField name="state" fullWidth placeholder="State" />
        </Stack>
      )}

      {properties?.country && (
        <Stack gap={1} mb={1}>
          <Typography variant="body1" fontWeight={500}>
            Country
          </Typography>
          <TextField name="country" fullWidth placeholder="Country" />
        </Stack>
      )}
    </Box>
  );
};
export default AddressFieldPreview;
